/**
 * @overview Module 'id-config' provides following values: signin, signout,
 *  settings and register URLs, translations for button labels, current
 *  environment (including identity and IDP endpoint URLs).
 * @namespace idcta
 */
define(['idcta/config', 'idcta/translations', 'idcta/apiUtils', 'idcta/logger'], function (config, translations, apiUtils, logger) {

    var hostnameParts = window.location.host.split('.');
    var tld;

    // Case if environment is running on *.co.uk domain
    if (hostnameParts[hostnameParts.length - 2] === 'co' && hostnameParts[hostnameParts.length - 1] === 'uk') {
        tld = hostnameParts[hostnameParts.length - 3] + '.co.uk';
    } else {
        tld = hostnameParts[hostnameParts.length - 2] + '.' + hostnameParts[hostnameParts.length - 1];
    }
    config = apiUtils.appendProductToConfig(config);

    var exports = {
        announce_url: apiUtils.alignTldWithHostname(config.announce_url),
        'bbcid-v5': config['bbcid-v5'],
        child_parent_linking_url: config.child_parent_linking_url,
        'id-availability': config['id-availability'],
        identity: {
            cookieAgeDays: config.identity.cookieAgeDays,
            accessTokenCookieName: config.identity.accessTokenCookieName,
            idSignedInCookieName: config.identity.idSignedInCookieName
        },
        privacy_settings_url: config.privacy_settings_url,
        ptrt: window.location.href,
        register_url: apiUtils.alignTldWithHostname(config.register_url),
        settings_url: config.settings_url,
        signin_url: apiUtils.alignTldWithHostname(config.signin_url),
        signout_url: config.signout_url,
        status_url: config.status_url,
        tld: tld,
        tokenImprovement: config.tokenImprovement || 'RED',
        tokenRefresh: config.tokenRefresh || false,
        tokenRefresh_signout_url: apiUtils.alignTldWithHostname(config.tokenRefresh_signout_url),
        tokenRefresh_url: apiUtils.alignTldWithHostname(config.tokenRefresh_url),
        translation_signedin: translations.translation_statusbar_signedin,
        translation_signedout: translations.translation_statusbar_signedout
    };

    /*
    * Deprecated - config should be served only synchronously now
    */
    exports.getConfigAsync = function () {
        try {
            return {
                then: function (success) {
                    return success(exports);
                }
            };
        } catch (err) {
            logger.logCaughtError(err);
        }
    };

    /*
    * Deprecated - config should be served without get function
    */
    exports.getConfig = function () {
        return exports;
    };
    return exports;
});
